var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.textmessages && !_vm.loadingTextmessages)?_c('div',_vm._l((_vm.textmessages),function(textmessage){return _c('div',{staticClass:"card mt-3",attrs:{"textmessage":textmessage}},[_c('div',{staticClass:"card-body p-2 card-message",domProps:{"innerHTML":_vm._s(textmessage)}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }